import React, { FC } from 'react';
import { Controller } from 'react-hook-form';

import { SelectField } from 'components';

type ControlledSelectFieldProps = {
  control: any;
  fieldName: string;
  label?: string;
  defaultValue?: string;
  options?: any;
};

const ControlledSelectField: FC<ControlledSelectFieldProps> = ({
  control,
  fieldName,
  label,
  defaultValue = '',
  ...restProps
}) => (
  <Controller
    control={control}
    name={fieldName}
    defaultValue={defaultValue}
    render={({ field, fieldState }) => (
      <SelectField
        label={label}
        name={field.name}
        onChange={field.onChange}
        onBlur={field.onBlur}
        value={field.value}
        isError={fieldState.invalid}
        errorMsg={fieldState.error?.message}
        field={field}
        {...restProps}
      />
    )}
  />
);

export default ControlledSelectField;
